import {
  BookOpenIcon,
  DumbbellIcon,
  LayoutListIcon,
  ClipboardCheckIcon,
  MapPinnedIcon,
  AccessibilityIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const kitContents: { icon: LucideIcon; title: string; description: string }[] = [
  {
    icon: BookOpenIcon,
    title: '8 Volumi Completi',
    description:
      'Un volume per ogni fascia scolastica, dalla 1ª primaria alla 5ª superiore: un percorso continuo dai 6 ai 19 anni.',
  },
  {
    icon: DumbbellIcon,
    title: '2.752 Esercizi Pronti',
    description:
      'Attivazioni, schede complete, banche di esercizi, giochi e circuiti. Ogni esercizio ha un nome e una descrizione operativa.',
  },
  {
    icon: LayoutListIcon,
    title: 'Unità Già Strutturate',
    description: 'Ogni unità segue sempre la stessa anatomia: apri la pagina e la lezione di oggi è già pronta.',
  },
  {
    icon: ClipboardCheckIcon,
    title: 'Valutazione Già Scritta',
    description:
      'Griglie di osservazione, rubriche a 4 livelli e descrittori con il voto in decimi, pronti per il registro elettronico.',
  },
  {
    icon: MapPinnedIcon,
    title: 'Palestra, Cortile o Aula',
    description:
      'Ogni unità dichiara la versione per palestra intera, mezza palestra, spazio esterno e aula. Con materiale povero.',
  },
  {
    icon: AccessibilityIcon,
    title: 'Inclusione Reale',
    description:
      'Variante inclusiva in ogni scheda e ruoli attivi per l’alunno esonerato: nessuno resta seduto a guardare.',
  },
]
